import { SignIn } from "@clerk/react";

import { clerkAppearance } from "../auth/clerkAppearance";
import "../auth/Auth.css";
import BrandWordmark from "../components/BrandWordmark";

/**
 * The Clerk sign-in experience — the only public authentication screen.
 *
 * Clerk owns the form, the credentials, and the session. OMJ VISION never sees
 * a password.
 *
 * Clerk also owns the heading. Its title tracks the step ("Sign in to
 * OMJ VISION", then "Check your email"), so an `<h1>` of our own above it would
 * both duplicate it and go stale on the verification step.
 *
 * No `signUpUrl` and no registration link: OMJ VISION is invite-only, and the
 * only route to `<SignUp>` is an invitation ticket (see AcceptInvitationPage).
 */
function SignInPage() {
  return (
    <main className="auth-shell">
      <section className="auth-card">
        <BrandWordmark size="sm" className="auth-kicker" />

        <div className="auth-clerk">
          <SignIn
            routing="path"
            path="/sign-in"
            forceRedirectUrl="/goldbot"
            appearance={clerkAppearance}
          />
        </div>

        <p className="auth-card__note">Access is by administrator invitation only.</p>
      </section>
    </main>
  );
}

export default SignInPage;
